import { Component, OnInit, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

import { ModalControl } from '../../../modal-control/modal-control.component';
import { ConfigOption, ConfigResult, ConfigStorage } from './grid-config.model';
import { SettingService } from '../../../../services/setting/setting.service';
import { NotifyService } from '../../../../services/notify/notify.service';
import { TranslateService } from '../../../../services/translate/translate.service';
import { MobileMaxWidth } from '../../../../constants/responsive';

@Component({
  selector: 'sd-grid-config',
  templateUrl: './grid-config.component.html',
  styleUrls: ['../../../../assets/css/button.scss',
    '../../../../assets/css/scrollbar.scss',
    '../../../../assets/css/box.scss',
    './grid-config.component.scss']
})
export class GridConfigComponent implements OnInit {
  isMobileOrTablet = window.innerWidth < MobileMaxWidth;
  @ViewChild('modal') modal: ModalControl;
  @Output() sdChange = new EventEmitter<ConfigResult>();

  option: ConfigOption;
  storage: ConfigStorage;
  constructor(
    private ref: ChangeDetectorRef,
    private notifyService: NotifyService,
    private settingService: SettingService,
    private translateService: TranslateService) { }

  ngOnInit() {
  }

  async setOption(option: ConfigOption) {
    this.ref.detectChanges();
    this.option = option;
    await this.init();
    this.emitOnChange();
  }

  private async init() {
    if (this.option.key) {
      const storage: ConfigStorage = await this.settingService.get(this.option.key).catch(() => undefined);
      try {
        if (!storage) {
          this.settingService.remove(this.option.key).catch(console.error);
          this.initDefault();
          return;
        }
        this.storage = storage;

        // Loại bỏ những column đã bị xóa khỏi originColumns
        this.storage.columnConfigs = this.storage.columnConfigs
          .filter(column => this.option.columns.some(e => e.field === column.originColumn.field));

        // Thêm những column mới vào storage nếu có
        this.option.columns.forEach(column => {
          if (!this.storage.columnConfigs.some(e => e.originColumn.field === column.field)) {
            this.storage.columnConfigs.push({
              originColumn: {
                field: column.field,
                title: column.title,
                width: column.width,
                fixed: column.fixed
              },
              hidden: false,
              fixed: column.fixed
            });
          }
        });

        // Cập nhật originColumn
        this.storage.columnConfigs.forEach(column => {
          const originColumn = this.option.columns.find(e => e.field === column.originColumn.field);
          if (originColumn) {
            Object.assign(column.originColumn, {
              title: originColumn.title,
              width: originColumn.width,
              fixed: originColumn.fixed
            });
          }
        });
      } catch (ex) {
        this.settingService.remove(this.option.key).catch(console.error);
        this.initDefault();
      }
    } else {
      this.initDefault();
    }
  }

  private initDefault() {
    this.storage = {};
    this.storage.pageSize = this.option.pageSize;
    this.storage.columnConfigs = [];
    this.option.columns.forEach(column => {
      this.storage.columnConfigs.push({
        originColumn: {
          field: column.field,
          title: column.title,
          width: column.width,
          fixed: column.fixed
        },
        hidden: false,
        fixed: column.fixed
      });
    });
  }

  open() {
    this.modal.open();
  }

  save() {
    if (!Number.isSafeInteger(+this.storage.pageSize)) {
      this.notifyService.notify.warning(this.translateService.translate('Page size must be an integer'));
      return;
    }
    if (this.storage.pageSize > 200) {
      this.notifyService.notify.warning(this.translateService.translate('Page size is too large'));
      return;
    }
    this.settingService.set(this.option.key, this.storage);
    this.emitOnChange();
    this.modal.close();
    this.ref.detectChanges();
  }

  reset() {
    this.settingService.remove(this.option.key);
    this.initDefault();
    // this.reload();
    this.emitOnChange();
    this.modal.close();
    this.ref.detectChanges();
  }

  moveColumnUp(index: number) {
    const temp = this.storage.columnConfigs[index];
    this.storage.columnConfigs[index] = this.storage.columnConfigs[index - 1];
    this.storage.columnConfigs[index - 1] = temp;
  }

  moveColumnDown(index: number) {
    const temp = this.storage.columnConfigs[index];
    this.storage.columnConfigs[index] = this.storage.columnConfigs[index + 1];
    this.storage.columnConfigs[index + 1] = temp;
  }

  emitOnChange() {
    const pageSize = +this.storage.pageSize || this.option.pageSize;
    const columns = this.option.columns.filter(column => {
      // Hidden column theo config
      // Lấy các thuộc tính Title, Width, Fixed từ config
      const columnConfig = this.storage.columnConfigs.find(e => e.originColumn.field === column.field);
      if (columnConfig) {
        column.title = columnConfig.title || column.title;
        column.width = columnConfig.width || column.width;
        column.fixed = columnConfig.fixed;
        return !columnConfig.hidden;
      }
      return true;
    }).sort((current, next) => {
      // Sắp xếp theo config
      const currentIndex = this.storage.columnConfigs.findIndex(e => e.originColumn.field === current.field);
      const nextIndex = this.storage.columnConfigs.findIndex(e => e.originColumn.field === next.field);
      return currentIndex - nextIndex;
    }).filter(column => {
      // Hidden column theo option truyền vào
      if (column.hidden === undefined) {
        return true;
      }
      if (typeof (column.hidden) === 'boolean') {
        return !column.hidden;
      }
      if (typeof (column.hidden) === 'function') {
        return !column.hidden();
      }
      return false;
    });
    const result: ConfigResult = {
      pageSize,
      columns,
      fixedColumns: columns.filter(e => e.fixed),
      normalColumns: columns.filter(e => !e.fixed)
    };
    this.sdChange.emit(result);
  }
}
